<template>
  <div class="navbar-scroll">
    <el-menu class="navbar" mode="horizontal">
      <div class="navbar-left">
        <button class="menu-trigger" type="button" v-if="showSidebar">
          <hamburger :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
        </button>
        <img class="cur navbar-logo" src="@/assets/images/hurix.png" @click="goHome" v-else>
        <breadcrumb></breadcrumb>
      </div>
      <div class="avatar-container">
        <div class="shelf-info" @click="$router.push('/shop/authorizedStore')">
          <i class="fi fi-br-link-alt"></i>
          <span>{{ $t('product.authorizedStore') }}</span>
        </div>

        <el-tooltip class="item" effect="dark" :content="$t('system.comingSoon')" placement="bottom">
          <div class="shelf-info">
            <i class="fi fi-ss-book-alt"></i>
            <span>{{ $t('product.rulesCenter') }}</span>
          </div>
        </el-tooltip>
        <div class="shelf-info" v-if="!managerFlag && !shopFlag && shopApplyFlag === 1">
          <i class="fi fi-sr-assessment-alt"></i>
          <span @click="$router.push({path: '/shopApply',query: {email: email}})">
            {{ $t('product.applyForEntry') }}
          </span>
        </div>
        <!--  通知  -->
        <div class="shelf-info" v-if="name" @click.stop="goMessageIm('2')">
          <el-badge :value="systemUnReadNumber || null">
            <i class="fi fi-ss-bell"></i>
            {{ $t('im.messageNotifications') }}
          </el-badge>
        </div>
        <!--  Message  -->
        <div class="shelf-info" @mouseenter="serviceColor='#e14643'" @mouseleave="serviceColor='#303133'" v-if="name"
             @click.stop="goNewWindow('1')">
          <el-badge :value="unReadCount || null">
            <i class="fi fi-sr-headset"></i>
            {{ $t('im.customerService') }}
          </el-badge>
        </div>
        <!--  国际化  -->
        <div class="shelf-info" v-if="showSidebar">
          <Internationalization :isShowLanguage="false" :fontColor="'#64748B'"></Internationalization>
        </div>
        <div class="shelf-info-line"></div>
        <!--  我的账户  -->
        <el-dropdown trigger="click">
          <div class="avatar-wrapper">
            <el-badge :value="phone ? null : 1">
              <span class="name-wrapper">
                 <i class="fi fi-sr-user text-primary text-xs"></i>
              </span>
              <span style="color: #1e293b;">{{ name }}</span>
            </el-badge>
            <i class="el-icon-arrow-down ml_10"></i>
          </div>
          <el-dropdown-menu class="user-dropdown" slot="dropdown">
            <router-link class="inlineBlock" to="/">
              <el-dropdown-item>
                {{ $t('system.home') }}
              </el-dropdown-item>
            </router-link>
            <router-link class="inlineBlock" to="/shop/myAccount">
              <el-dropdown-item>
                <el-badge :value="phone ? null : 1">
                  {{ $t('system.myAccount') }}
                </el-badge>
              </el-dropdown-item>
            </router-link>
            <el-dropdown-item divided>
              <span @click="logout" style="display:block;">{{ $t('system.signOut') }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-menu>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Internationalization from "@/components/Internationalization";
import logo from "@/assets/logo/hurixWhite2.png";
import {navigateFromMenu} from '@/utils/pageNavigation'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    Internationalization,
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'name',
      'userId'
    ]),
    ...mapState({
      phone: state => state.user.phone,
      companyName: state => state.user.companyName,
      shopFlag: state => state.user.shopFlag,
      shopApplyFlag: state => state.user.shopApplyFlag,
      managerFlag: state => state.user.managerFlag,
      email: state => state.user.email
    })
  },
  data() {
    return {
      unReadCount: 0,
      systemUnReadNumber: 0,
      serviceColor: '#303133',
      logo,
      isFirst: true,
    }
  },
  props: {
    showSidebar: {
      type: Boolean,
      default: true
    },
  },
  created() {
    let that = this;
    this.$store.dispatch('getImInfo').then(res => {
      // 登录环信
      setTimeout(() => {
        that.getContactList();
      }, 300)
    })
    this.$eventBus.$on('im-get-num', (msg) => {
      setTimeout(() => {
        that.getContactList();
      }, 200)
    })
    this.$store.dispatch('IsNeedEntry')
  },
  beforeDestroy() {
    // this.$eventBus.$off('im-get-num')
  },
  methods: {
    resetPageCache() {
      return navigateFromMenu(this.$router, this.$store, '/home')
    },
    goHome() {
      return this.resetPageCache()
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$confirm(this.$t('system.sureLogout'), this.$t('message.information'), {
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          // location.reload() // 为了重新实例化vue-router对象 避免bug

          // 退出登录后通过路由跳转，避免整页刷新。
          if (this.$route.path !== '/login') {
            this.$router.replace('/login').catch(() => {})
          }
        })
      }).catch(() => {
        return false
      })
    },
    goNewWindow(imType) {
      this.unReadCount = 0;
      const routeData = this.$router.resolve({
        path: '/IM',
        query: {
          imType
        }
      });
      // 在新窗口中打开页面
      window.open(routeData.href, '_blank');
    },
    goMessageIm(imType) {
      // const route = this.$router.resolve({
      //   path: "/notifications",
      //   query: {
      //     imType,
      //     hurixUnReadNum: this.systemUnReadNumber
      //   }
      // })
      // window.open(route.href, '_blank');
      this.$router.push({
        path: "/notifications",
        query: {
          imType,
          hurixUnReadNum: this.systemUnReadNumber
        }
      })
      if (imType === '2') {
        this.systemUnReadNumber = 0;
      }
    },
    getContactList() {
      this.$webIM.conn.getServerConversations({pageSize: 500, cursor: ''}).then(async (res) => {
        let data = res.data;
        let contactArr = data.conversations && Array.isArray(data.conversations) ? data.conversations : [];
        let emailList = contactArr.find(item => item.conversationId === "hurix")
        let allContactList = contactArr.filter(item => item.conversationType === "groupChat");
        this.updateUnReadNum(allContactList)
        this.systemUnReadNum(emailList)
      }).catch(async err => {
        if(this.isFirst) {
          this.isFirst = false
          await this.$store.dispatch('getImInfo');
          setTimeout(() => {
            this.getContactList()
          }, 500)
        }
      })
    },
    updateUnReadNum(contactArr) {
      if (Array.isArray(contactArr) && contactArr.length > 0) {
        this.unReadCount = contactArr.reduce((accumulator, currentItem) => accumulator + currentItem.unReadCount, 0) || 0;
      } else {
        this.unReadCount = 0;
      }
    },
    systemUnReadNum(obj) {
      this.systemUnReadNumber = obj ? obj.unReadCount : 0;
      this.$store.dispatch('updateSystemUnreadCount', this.systemUnReadNumber);
      if (this.$route.query.imType === '2') {
        this.systemUnReadNumber = 0;
      }
      if (this.systemUnReadNumber) {
        // 从IM消息中提取进度信息
        let shouldShowNotification = true;
        // console.log('🚀 ~ Navbar.vue:216 ~ obj:', obj);
        if (obj && obj.lastMessage && obj.lastMessage.ext && obj.lastMessage.ext.ext) {
          // 只有 type === '8' 才是商品同步信息
          if (obj.lastMessage.ext.type === '8') {
            const extData = JSON.parse(obj.lastMessage.ext.ext);
            // 获取现有的商品状态列表
            let productStatusList = [];
            const existingData = sessionStorage.getItem('syncProductStatusList');
            if (existingData) {
              try {
                productStatusList = JSON.parse(existingData);
              } catch (e) {
                productStatusList = [];
              }
            }
            // 查找是否已存在该商品的状态信息
            const existingIndex = productStatusList.findIndex(item => item.productId === extData.productId);
            const newProductStatus = {
              productId: extData.productId || '',
              status: extData.status || '0',
              id: extData.id || '',
              timestamp: Date.now()
            };
            if (existingIndex !== -1) {
              // 更新现有商品的状态
              productStatusList[existingIndex] = newProductStatus;
            } else {
              // 添加新商品的状态
              productStatusList.push(newProductStatus);
            }
            // 存储商品状态列表到 sessionStorage
            sessionStorage.setItem('syncProductStatusList', JSON.stringify(productStatusList));
            // 存储总进度（用于进度条显示），只保存最大的进度值，避免进度条回退
            const currentProgressData = sessionStorage.getItem('syncProgress');
            let currentProgress = 0;
            if (currentProgressData) {
              try {
                currentProgress = parseInt(JSON.parse(currentProgressData).progress) || 0;
              } catch (e) {
                currentProgress = 0;
              }
            }
            const newProgress = parseInt(extData.progress) || 0;
            // 只保存更大的进度值
            if (newProgress > currentProgress) {
              sessionStorage.setItem('syncProgress', JSON.stringify({
                progress: extData.progress || '0',
                timestamp: Date.now()
              }));
              currentProgress = newProgress;
            }
            // 根据保存的最大进度值判断是否完成
            const isCompleted = currentProgress === 100;
            sessionStorage.setItem('checkIfSyncCompleted', isCompleted ? 'true' : 'false');
            shouldShowNotification = isCompleted;
            // 如果同步完成，通知 product-sync 页面初始化数据
            if (isCompleted) {
              this.$eventBus.$emit('sync-completed');
            }
          }
        }
        if (shouldShowNotification) {
          const notification = this.$notify({
            title: this.$t("message.information"),
            message: this.$t('system.unreadSystemNotifications'),
            duration: 5000,
            position: 'bottom-right',
            offset: 5,
            type: 'primary',
            iconClass: 'el-icon-info',
            customClass: 'my-custom-notification',
          onClick: () => {
            this.goMessageIm('2')
            notification.close()
          }
        });
      }
    }
    },
  }
}
</script>
<style lang="scss">
// 站内信提示通知
.el-notification {
  &.my-custom-notification {
    width: 340px;
    cursor: pointer;

    .el-notification__content {
      color: #606266;
      font-size: 16px;
      text-align: left;
    }

    .el-notification__title {
      font-weight: bold;
      color: #333;
    }
  }
}
</style>
<style lang="scss" scoped>
/deep/ .el-badge__content {
  top: 18px !important;
  //background-color: #ff7d3f !important;
  //border: #ff7d3f;
}

.navbar-scroll {
  width: 100%;
}

.navbar {
  width: max-content;
  min-width: 100%;
  box-sizing: border-box;
  height: 64px;
  line-height: 64px;
  border-radius: 0 !important;
  background-color: #fff;
  color: #64748B;
  display: flex;
  align-items: center;
  gap: 20px;
  box-shadow: rgba(0, 0, 0, 0) 0 0 0 0, rgba(0, 0, 0, 0) 0 0 0 0, rgba(0, 0, 0, 0.05) 0 1px 2px 0;
  .navbar-left {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    flex-wrap: nowrap;
    white-space: nowrap;

    /deep/ .app-breadcrumb {
      flex-shrink: 0;
    }
  }

  .nav-title {
    font-size: 18px;
    color: #1e293b;
    font-weight: 600;
    padding-left: 15px;
    white-space: nowrap;
  }

  .navbar-logo {
    height: 38px;
    margin-left: 20px;
    vertical-align: middle;
    margin-bottom: 5px;
    flex-shrink: 0;
  }

  .menu-trigger {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    padding: 0;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: #64748b;
    cursor: pointer;
    transition: all 0.15s ease;
    margin-left: 16px;

    &:hover {
      color: #f97316;
      background: rgba(249, 115, 22, 0.08);
    }
  }

  .shelf-info {
    display: inline-block;
    margin-right: 23px;
    cursor: pointer;
    line-height: 64px;
    color: #64748B;
    font-size: 14px;
    white-space: nowrap;
    &:hover {
      color: #f97316;
    }
    i {
      font-size: 16px;
      margin-right: 1px;
      position: relative;
      top: 2px;
    }
    span {
      font-size: 14px;
      margin-left: 1px;
    }
    .big-icon {
      font-size: 16px;
      margin-right: 2px;
      position: relative;
      top: 2px;
    }
  }

  .avatar-container {
    flex-shrink: 0;
    height: 64px;
    line-height: 64px;
    display: flex;
    align-items: center;
    margin-left: auto;
    padding-right: 35px;

    .shelf-info-line {
      width: 1px;
      height: 28px;
      background: #e8ecf1;
      margin-right: 20px;
    }

    .avatar-wrapper {
      cursor: pointer;
      color: #64748B;
      margin-right: -20px;
      position: relative;
      white-space: nowrap;

      .name-wrapper {
        display: inline-block;
        height: 28px;
        width: 28px;
        line-height: 28px;
        border-radius: 50%;
        background: #f9731626;
        text-align: center;
        color: #f97316;
        margin-right: 3px;
      }

      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 20px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue